import styled from "styled-components";
import { primaryColor, standardBorderRadius } from "utils/form-constants";

export const CardBlock = styled.div<{ isActive: boolean }>`
  width: 100%;
  border: 2px solid ${({ isActive }) => (isActive ? primaryColor : "#DBDBDB")};
  background: ${({ isActive }) => (isActive ? "#FFE1DD" : "transparent")};
  border-radius: ${standardBorderRadius};
  padding: 16px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  gap: 12px;

  h5 {
    font-size: 19px;
  }

  p {
    color: #575757;
    font-size: 15px;
  }
`;
